export const GET_CASH_PAID = "GET_CASH_PAID";
export const ADD_CASH_PAID = "ADD_CASH_PAID";
export const UPDATE_CASH_PAID = "UPDATE_CASH_PAID";
export const DELETE_CASH_PAID = "DELETE_CASH_PAID";
export const TOTAL_CASH_PAID = "TOTAL_CASH_PAID";

